/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_Seller_Bookings_Email_LabelInputs */

const en_checkout_seller_bookings_email_label = /** @type {(inputs: Checkout_Seller_Bookings_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bookings`)
};

/**
* | output |
* | --- |
* | "Bookings" |
*
* @param {Checkout_Seller_Bookings_Email_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const checkout_seller_bookings_email_label = /** @type {((inputs?: Checkout_Seller_Bookings_Email_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_Seller_Bookings_Email_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_checkout_seller_bookings_email_label(inputs)
});